import { render, staticRenderFns } from "./EditHouse.vue?vue&type=template&id=600952cb&scoped=true"
import script from "./EditHouse.vue?vue&type=script&lang=js"
export * from "./EditHouse.vue?vue&type=script&lang=js"
import style0 from "./EditHouse.vue?vue&type=style&index=0&id=600952cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600952cb",
  null
  
)

export default component.exports